const API_BASE_URL = process.env.REACT_APP_API_URL || "";

const safeRequest = async (url, payload) => {
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload || {}),
    });

    const data = await response.json().catch(() => ({}));

    return {
      ok: response.ok,
      ...data,
    };
  } catch (error) {
    // آمار نباید تجربه کاربر را خراب کند، پس خطا فقط در کنسول ثبت می‌شود.
    console.warn("Analytics request failed:", error);
    return {
      success: false,
      counted: false,
    };
  }
};

export const trackSiteVisit = ({ path, referrer } = {}) => {
  return safeRequest(`${API_BASE_URL}/api/analytics/site-view`, {
    path: path || window.location.pathname,
    referrer: referrer || document.referrer || "",
  });
};

export const trackContentView = ({ contentId, slug, path, referrer } = {}) => {
  return safeRequest(`${API_BASE_URL}/api/analytics/content-view`, {
    contentId,
    slug,
    path: path || window.location.pathname,
    referrer: referrer || document.referrer || "",
  });
};
